module.exports = __webpack_public_path__ + "static/media/Screen Shot 2022-05-30 at 10.00.08 PM.0104b066.png";